import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import { I18nProvider } from './i18n'

// Handle unhandled promise rejections from external libraries
window.addEventListener('unhandledrejection', (event) => {
  // Suppress checkout popup config errors from third-party extensions/libraries
  if (event.reason?.message?.includes('checkout popup config') ||
      event.reason?.message?.includes('No checkout popup config found')) {
    console.warn('Ignoring third-party checkout config error:', event.reason);
    event.preventDefault(); // Prevent uncaught error
  }
});

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
)
